import React from 'react';

export const YachtLogo = ({ className = "w-6 h-6" }: { className?: string }) => {
  return (
    <div className={`grid grid-cols-3 gap-0 ${className}`}>
      {[...Array(9)].map((_, i) => (
        <div 
          key={i} 
          className={`w-full h-full ${i % 2 === 0 ? 'bg-white' : 'bg-transparent'}`} 
        />
      ))}
    </div>
  );
};

export default YachtLogo;
